import React from 'react'
import {UseFormMethods} from 'react-hook-form'
import {Label} from 'lib/ui/typography'
import TextField from 'lib/ui/TextField'
import {useLeftyTemplate} from 'Event/template/Lefty'
import {useAttendeeVariables} from 'Event'

export default function Settings(props: {
  control: UseFormMethods['control']
  register: UseFormMethods['register']
}) {
  const {register} = props
  const template = useLeftyTemplate()
  const {welcomeText} = template

  const v = useAttendeeVariables()

  return (
    <>
      <Label>Text</Label>
      <TextField
        name="welcomeText"
        placeholder="Text"
        defaultValue={v(welcomeText)}
        aria-label="dashboard welcome text"
        inputProps={{
          ref: register,
        }}
        fullWidth
      />
    </>
  )
}
